import Layout from "@/components/layout/Layout";
import React from "react";
import { Outlet } from "react-router-dom";

const SettingsLayout: React.FC = () => {
  return (
    <Layout>
      <div className="min-h-screen">
        <Outlet />
      </div>
    </Layout>
  );
};

export default SettingsLayout;
